// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- 3rd Party
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import { ReportsBaseService } from './reports-base.service';
import { ReportListItem } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class ReportsMockService extends ReportsBaseService {


  constructor(protected modalService: NgbModal) {
    super(modalService);
  }

  loadReports(): void {
    const reports = new Array<ReportListItem>();
    reports.push({
      surveyName: 'My First Survey',
      lastUpdated: new Date(2018, 3, 5),
      viewLink: '#',
      downloadLink: '#'
    } as ReportListItem);

    reports.push({
      surveyName: 'My Second Survey',
      lastUpdated: new Date(2019, 2, 13),
      viewLink: '#',
      downloadLink: '#'
    } as ReportListItem);

    reports.push({
      surveyName: 'My Third Survey',
      lastUpdated: new Date(2019, 6, 21),
      viewLink: '#',
      downloadLink: '#'
    } as ReportListItem);

    this._reportsList$.next(reports);
  }

  getReportOnline(identifier: string): void {

  }

  getReportPdf(identifier: string): void { }
}
